import { gql } from '@apollo/client';
import config from 'config';

export const GET_FEEDBACK = gql`
    query GetFeedback($input: GetFeedbackInput!) {
        getFeedback(input: $input) {
            id
            collectionName
            docId
            contextType
            contextId
            feedbackReasons {
                id
                title
                value
                hasCustomValue
                enabled
                targetType
            }
            feedbackSubReason
        }
    }
`;

const feedbackIndex = config.algolia.algolia_prefix + 'feedback_updated';

export const GET_ALL_FEEDBACKS = gql`
query AlgoliaGetAllFeedbacks ($query : String!, $filters: String!, $hit : Number!, $page : Number!) {
  algoliaGetAllFeedbacks @algolia(__typename: "ALGOLIA_ALL_FEEDBACKS", index: ${feedbackIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;
